import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5003/api';

const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json'
  }
});

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export const authAPI = {
  login: (credentials) => api.post('/auth/login', credentials),
};

export const phoneAPI = {
  getAll: () => api.get('/phones'),
  getById: (id) => api.get(`/phones/${id}`),
  create: (data) => api.post('/phones', data),
  update: (id, data) => api.put(`/phones/${id}`, data),
  delete: (id) => api.delete(`/phones/${id}`),
  uploadImages: (phoneId, formData) => {
    return api.post(`/phones/${phoneId}/images`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
  },
  deleteImage: (imageId) => api.delete(`/phones/images/${imageId}`)
};

export const bidAPI = {
  create: (data) => api.post('/bids', data),
  getPhoneBids: (phoneId) => api.get(`/bids/phone/${phoneId}`),
  getMyBids: () => api.get('/bids/my-bids'),
  getAllBidsReport: () => api.get('/bids/report'),
  delete: (id) => api.delete(`/bids/${id}`)
};

export default api;
